import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a horizontal more dots icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <MoreHorizontalIcon width={12} />
 */
const MoreHorizontalIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M4.99967 8.3335C5.32931 8.3335 5.65154 8.43124 5.92562 8.61438C6.19971 8.79752 6.41333
            9.05781 6.53947 9.36236C6.66562 9.6669 6.69863 10.002 6.63432 10.3253C6.57001 10.6486 6.41127
            10.9456 6.17819 11.1787C5.9451 11.4118 5.64813 11.5705 5.32482 11.6348C5.00152 11.6991 4.66641
            11.6661 4.36187 11.54C4.05733 11.4138 3.79703 11.2002 3.61389 10.9261C3.43076 10.652 3.33301
            10.3298 3.33301 10.0002C3.33433 9.55854 3.51035 9.13538 3.82262 8.82311C4.1349 8.51083 4.55805
            8.33482 4.99967 8.3335V8.3335ZM8.33301 10.0002C8.33301 10.3298 8.43076 10.652 8.61389
            10.9261C8.79703 11.2002 9.05732 11.4138 9.36187 11.54C9.66641 11.6661 10.0015 11.6991 10.3248
            11.6348C10.6481 11.5705 10.9451 11.4118 11.1782 11.1787C11.4113 10.9456 11.57 10.6486 11.6343
            10.3253C11.6986 10.002 11.6656 9.6669 11.5395 9.36236C11.4133 9.05781 11.1997 8.79752 10.9256
            8.61438C10.6515 8.43124 10.3293 8.3335 9.99967 8.3335C9.55805 8.33482 9.1349 8.51083 8.82262
            8.82311C8.51034 9.13538 8.33433 9.55854 8.33301 10.0002ZM13.333 10.0002C13.333 10.3298 13.4308
            10.652 13.6139 10.9261C13.797 11.2002 14.0573 11.4138 14.3619 11.54C14.6664 11.6661 15.0015
            11.6991 15.3248 11.6348C15.6481 11.5705 15.9451 11.4118 16.1782 11.1787C16.4113 10.9456 16.57
            10.6486 16.6343 10.3253C16.6986 10.002 16.6656 9.6669 16.5395 9.36236C16.4133 9.05781 16.1997
            8.79752 15.9256 8.61438C15.6515 8.43124 15.3293 8.3335 14.9997 8.3335C14.5581 8.33482 14.1349
            8.51083 13.8226 8.82311C13.5103 9.13538 13.3343 9.55854 13.333 10.0002Z`}
        />
    </SvgIcon>
)

MoreHorizontalIcon.defaultProps = defaultProps

export { MoreHorizontalIcon }
